// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Application instance certificate / PKI configuration for the secure channel
 * (distinct from the user `Identity`). Required for Sign / SignAndEncrypt.
 */
export class CertificateConfig implements flatbuffers.IUnpackableObject<CertificateConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CertificateConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCertificateConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: CertificateConfig,
  ): CertificateConfig {
    return (obj || new CertificateConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCertificateConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: CertificateConfig,
  ): CertificateConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CertificateConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Path to the client application instance certificate (DER).
   */
  applicationCertPath(): string | null;
  applicationCertPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  applicationCertPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Path to the client application private key (PEM).
   */
  privateKeyPath(): string | null;
  privateKeyPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  privateKeyPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * PKI directory holding trusted peer certificates.
   */
  trustListDir(): string | null;
  trustListDir(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  trustListDir(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Directory where rejected peer certificates are written.
   */
  rejectListDir(): string | null;
  rejectListDir(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  rejectListDir(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Auto-trust the server certificate (INSECURE; for None / test only).
   */
  trustServerCertificate(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Create a self-signed application keypair if none exists at the paths above.
   */
  createKeypairIfMissing(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Verify the server certificate hostname against the endpoint.
   */
  verifyServerHostname(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  static startCertificateConfig(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addApplicationCertPath(
    builder: flatbuffers.Builder,
    applicationCertPathOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, applicationCertPathOffset, 0);
  }

  static addPrivateKeyPath(builder: flatbuffers.Builder, privateKeyPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, privateKeyPathOffset, 0);
  }

  static addTrustListDir(builder: flatbuffers.Builder, trustListDirOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, trustListDirOffset, 0);
  }

  static addRejectListDir(builder: flatbuffers.Builder, rejectListDirOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, rejectListDirOffset, 0);
  }

  static addTrustServerCertificate(builder: flatbuffers.Builder, trustServerCertificate: boolean) {
    builder.addFieldInt8(4, +trustServerCertificate, +false);
  }

  static addCreateKeypairIfMissing(builder: flatbuffers.Builder, createKeypairIfMissing: boolean) {
    builder.addFieldInt8(5, +createKeypairIfMissing, +true);
  }

  static addVerifyServerHostname(builder: flatbuffers.Builder, verifyServerHostname: boolean) {
    builder.addFieldInt8(6, +verifyServerHostname, +true);
  }

  static endCertificateConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createCertificateConfig(
    builder: flatbuffers.Builder,
    applicationCertPathOffset: flatbuffers.Offset,
    privateKeyPathOffset: flatbuffers.Offset,
    trustListDirOffset: flatbuffers.Offset,
    rejectListDirOffset: flatbuffers.Offset,
    trustServerCertificate: boolean,
    createKeypairIfMissing: boolean,
    verifyServerHostname: boolean,
  ): flatbuffers.Offset {
    CertificateConfig.startCertificateConfig(builder);
    CertificateConfig.addApplicationCertPath(builder, applicationCertPathOffset);
    CertificateConfig.addPrivateKeyPath(builder, privateKeyPathOffset);
    CertificateConfig.addTrustListDir(builder, trustListDirOffset);
    CertificateConfig.addRejectListDir(builder, rejectListDirOffset);
    CertificateConfig.addTrustServerCertificate(builder, trustServerCertificate);
    CertificateConfig.addCreateKeypairIfMissing(builder, createKeypairIfMissing);
    CertificateConfig.addVerifyServerHostname(builder, verifyServerHostname);
    return CertificateConfig.endCertificateConfig(builder);
  }

  unpack(): CertificateConfigT {
    return new CertificateConfigT(
      this.applicationCertPath(),
      this.privateKeyPath(),
      this.trustListDir(),
      this.rejectListDir(),
      this.trustServerCertificate(),
      this.createKeypairIfMissing(),
      this.verifyServerHostname(),
    );
  }

  unpackTo(_o: CertificateConfigT): void {
    _o.applicationCertPath = this.applicationCertPath();
    _o.privateKeyPath = this.privateKeyPath();
    _o.trustListDir = this.trustListDir();
    _o.rejectListDir = this.rejectListDir();
    _o.trustServerCertificate = this.trustServerCertificate();
    _o.createKeypairIfMissing = this.createKeypairIfMissing();
    _o.verifyServerHostname = this.verifyServerHostname();
  }

  unpackFields(...fields: string[]): CertificateConfigT {
    const t = new CertificateConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("application_cert_path")) {
      t.applicationCertPath = this.applicationCertPath();
    }
    if (fieldSet.has("private_key_path")) {
      t.privateKeyPath = this.privateKeyPath();
    }
    if (fieldSet.has("trust_list_dir")) {
      t.trustListDir = this.trustListDir();
    }
    if (fieldSet.has("reject_list_dir")) {
      t.rejectListDir = this.rejectListDir();
    }
    if (fieldSet.has("trust_server_certificate")) {
      t.trustServerCertificate = this.trustServerCertificate();
    }
    if (fieldSet.has("create_keypair_if_missing")) {
      t.createKeypairIfMissing = this.createKeypairIfMissing();
    }
    if (fieldSet.has("verify_server_hostname")) {
      t.verifyServerHostname = this.verifyServerHostname();
    }
    return t;
  }
}

export class CertificateConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public applicationCertPath: string | Uint8Array | null = null,
    public privateKeyPath: string | Uint8Array | null = null,
    public trustListDir: string | Uint8Array | null = null,
    public rejectListDir: string | Uint8Array | null = null,
    public trustServerCertificate: boolean = false,
    public createKeypairIfMissing: boolean = true,
    public verifyServerHostname: boolean = true,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const applicationCertPath =
      this.applicationCertPath !== null ? builder.createString(this.applicationCertPath!) : 0;
    const privateKeyPath =
      this.privateKeyPath !== null ? builder.createString(this.privateKeyPath!) : 0;
    const trustListDir = this.trustListDir !== null ? builder.createString(this.trustListDir!) : 0;
    const rejectListDir =
      this.rejectListDir !== null ? builder.createString(this.rejectListDir!) : 0;

    return CertificateConfig.createCertificateConfig(
      builder,
      applicationCertPath,
      privateKeyPath,
      trustListDir,
      rejectListDir,
      this.trustServerCertificate,
      this.createKeypairIfMissing,
      this.verifyServerHostname,
    );
  }

  clone(): CertificateConfigT {
    const obj = new CertificateConfigT();
    obj.applicationCertPath = this.applicationCertPath;
    obj.privateKeyPath = this.privateKeyPath;
    obj.trustListDir = this.trustListDir;
    obj.rejectListDir = this.rejectListDir;
    obj.trustServerCertificate = this.trustServerCertificate;
    obj.createKeypairIfMissing = this.createKeypairIfMissing;
    obj.verifyServerHostname = this.verifyServerHostname;
    return obj;
  }

  equals(other: CertificateConfigT): boolean {
    if (this.applicationCertPath !== other.applicationCertPath) return false;
    if (this.privateKeyPath !== other.privateKeyPath) return false;
    if (this.trustListDir !== other.trustListDir) return false;
    if (this.rejectListDir !== other.rejectListDir) return false;
    if (this.trustServerCertificate !== other.trustServerCertificate) return false;
    if (this.createKeypairIfMissing !== other.createKeypairIfMissing) return false;
    if (this.verifyServerHostname !== other.verifyServerHostname) return false;
    return true;
  }
}

export function verifyCertificateConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
  } finally {
    verifier.popDepth();
  }
}
